<mat-card>
  <h2 translate="preferences/account"></h2>
  <h5 data-testid="account-email">{{ loggedUser.email }}</h5>
  <mat-card-content>
    <form [formGroup]="form">
      <app-select
        data-testid="account-language"
        [labelKey]="'preferences/language'"
        [control]="form.controls.language"
        [items]="languages"></app-select>

      <mat-form-field data-testid="account-name">
        <mat-label translate="preferences/name"></mat-label>
        <input matInput formControlName="realname" />
      </mat-form-field>

      <app-select
        data-testid="account-timezone"
        [enableTypeahead]="true"
        [control]="form.controls.timezone"
        [items]="timezoneItems"
        [labelKey]="timezoneLabel">
      </app-select>

      <app-select
        data-testid="account-gender"
        [control]="form.controls.gender"
        [items]="genders"
        [labelKey]="'preferences/gender'">
      </app-select>
      <mat-hint [innerHTML]="'preferences/gender/hint' | translate" class="alc-smaller-text"></mat-hint>
    </form>
  </mat-card-content>
</mat-card>
